import React, { useEffect, useState } from "react";
import moment from "moment";

import { capitalizeString } from "../../utils/utils";
import ApexChart from "./apexChart";
import { useSelector } from "react-redux";
import {
  selectCurrentChallenges,
  selectDeletedChallenges,
  selectPastChallenges,
} from "../challenges/tabs/manage-challenges/manageChallengesSlice";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";

const ChallengeInsights = () => {
  let { challengeId } = useParams();

  const currentChallenges = useSelector(selectCurrentChallenges);
  const pastChallenges = useSelector(selectPastChallenges);
  const deletedChallenges = useSelector(selectDeletedChallenges);

  const [challenge, setChallenge] = useState();
  const [data, setData] = useState();

  const challenges = [
    ...currentChallenges,
    ...pastChallenges,
    ...deletedChallenges,
  ];

  const getGenderData = (ch) => {
    const types = {};
    const participantsData = {};
    for (let p of ch.participants) {
      const date = moment(p.created_at).format("DD/MM/YYYY");
      if (participantsData[date]) {
        participantsData[date] = participantsData[date] + 1;
      } else {
        participantsData[date] = 1;
      }
      if (types[p.participant_user__gender]) {
        types[p.participant_user__gender] =
          types[p.participant_user__gender] + 1;
      } else {
        types[p.participant_user__gender] = 1;
      }
    }

    let challengeStartDate = moment(ch?.start_date);
    const challengeEndDate = moment();
    const newParticipantsData = {};

    while (challengeStartDate <= challengeEndDate) {
      newParticipantsData[challengeStartDate.format("DD/MM/YYYY")] =
        participantsData[challengeStartDate.format("DD/MM/YYYY")] ?? 0;

      challengeStartDate.add(1, "days");
    }
    return {
      gender: { categories: Object.keys(types), data: Object.values(types) },
      participants: {
        categories: Object.keys(newParticipantsData),
        data: Object.values(newParticipantsData),
      },
    };
  };

  useEffect(() => {
    const ch = [
      ...currentChallenges,
      ...pastChallenges,
      ...deletedChallenges,
    ].find((ch) => ch.challenge_id === challengeId);

    if (ch) {
      setChallenge(ch);
      const graphData = getGenderData(ch);
      setData(graphData);
    }
  }, [challengeId]);

  if (!challenge) {
    return <></>;
  }

  return (
    <div>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "14px" }}>
        <div
          style={{
            display: "flex",
            width: "50%",
            justifyContent: "flex-start",
          }}
        >
          <span style={{ fontWeight: "bold" }}>Challenge Name : </span>
          <span style={{ paddingLeft: "20px" }}>
            {challenge?.challenge_name}
          </span>
        </div>
        <div
          style={{
            display: "flex",
            width: "50%",
            justifyContent: "flex-start",
          }}
        >
          <span style={{ fontWeight: "bold" }}>Start Date : </span>
          <span style={{ paddingLeft: "20px" }}>
            {moment(challenge?.start_date).format("MMM DD, YYYY")}
          </span>
        </div>
        <div
          style={{
            display: "flex",
            width: "50%",
            justifyContent: "flex-start",
          }}
        >
          <span style={{ fontWeight: "bold" }}>End Date : </span>
          <span style={{ paddingLeft: "20px" }}>
            {moment(challenge?.end_Date).format("MMM DD, YYYY")}
          </span>
        </div>
        <div
          style={{
            display: "flex",
            width: "50%",
            justifyContent: "flex-start",
          }}
        >
          <span style={{ fontWeight: "bold" }}>No of Participants : </span>
          <span style={{ paddingLeft: "20px" }}>
            {challenge?.participants.length}
          </span>
        </div>
        <div
          style={{
            display: "flex",
            width: "50%",
            justifyContent: "flex-start",
          }}
        >
          <span style={{ fontWeight: "bold" }}>Group Name : </span>
          <span style={{ paddingLeft: "20px" }}>
            {challenge?.group?.group_name}
          </span>
        </div>
      </Box>
      <div style={{ marginTop: "32px" }}>
        <ApexChart
          type="bar"
          data={data.gender.data}
          categories={data.gender.categories.map((c) => capitalizeString(c))}
          height={300}
          width={300}
          title="Gender Graph"
        />
      </div>

      <div style={{ marginTop: "32px", marginLeft: "8px " }}>
        <ApexChart
          type="line"
          data={data.participants.data}
          categories={data.participants.categories}
          width={800}
          height={422}
          title="Participants Graph"
        />
      </div>
    </div>
  );
};

export default ChallengeInsights;
